import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from 'morpheus-ui';
import { ComponentProps, ReactNode } from 'react';
import { VariantProps } from 'tailwind-variants';
import { Typography } from '../../molecules/Typography';
import { alert, alertIcon } from './variants';

type AlertProps = ComponentProps<'div'> &
  VariantProps<typeof alert> & {
    title?: string | ReactNode;
    message?: string | ReactNode;
    size?: string;
    variant: string;
  };

const iconMap = {
  info: InfoIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  success: SuccessIcon,
};

function Alert({
  variant = 'info',
  title,
  message,
  size = 'regular',
  className,
  ...props
}: AlertProps) {
  const IconComponent = iconMap[variant];

  return (
    <div
      {...props}
      className={alert({ variant, className }) + ' border-mono-color-white'}
    >
      <IconComponent className={alertIcon({ size, variant })} />
      <div className='m-auto flex-1'>
        {typeof title === 'string' ? (
          <Typography
            weight='bold'
            size='h6'
            className={`${variant === 'warning' ? 'text-card-color-negative' : ''}`}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
        {typeof message === 'string' ? (
          <Typography
            className={`${variant === 'warning' ? 'text-card-color-negative' : ''}`}
          >
            {message}
          </Typography>
        ) : (
          message
        )}
        {props.children}
      </div>
    </div>
  );
}

export { Alert };
